import { render, staticRenderFns } from "./main.vue?vue&type=template&id=0c979408"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c979408')) {
      api.createRecord('0c979408', component.options)
    } else {
      api.reload('0c979408', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=0c979408", function () {
      api.rerender('0c979408', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/staffSelect/main.vue"
export default component.exports